module.exports = __webpack_public_path__ + "img/pen-icon-blue.478604c5.svg";